export function createEPIQuery(props, addressId) {
  const keys = ['siteId', 'feed', 'url', 'filtersUsed'];

  const query = keys.reduce((acc, key) => {
    if(['feed', 'filtersUsed'].includes(key)) {
      acc.push(key + '=' + (props[key] ? 1 : 0));
    } else if(key === 'url') {
      acc.push(key + '=' + props[key].replace(/^\//, '').replace(/\//gm, '-'));
    } else {
      acc.push(key + '=' + (props[key] || 'null'));
    }
    return acc;
  }, addressId ? ['addressId=' + addressId] : []);

  return query.length ? '?' + query.join('&') : '';
}